export const ActionTypes = {
  LOADING: "UPDATE_PROS_LOADING",
  ERROR: "UPDATE_PROS_ERROR",
  SUCCESS: "UPDATE_PROS_SUCCESS",
};
